// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2297":"a26b6e63","2589":"d6fdf0fb","3855":"c172b2c4"}[chunkId] + ".css";
};